import parse from 'html-react-parser'
import { toast } from 'sonner'
import { Trans } from 'react-i18next'
import { renderToString } from 'react-dom/server'
export const toastUtils = {
  success: (message, options = {}) => {
    toast.success(renderToString(<Trans i18nKey='ui.success' />), {
      description: parse(parseMessage(message)),
      descriptionClassName: 'max-h-96 overflow-auto',
      ...options
    })
  },
  error: (message, options = {}) => {
    toast.error(renderToString(<Trans i18nKey='ui.error' />), {
      description: parse(parseMessage(message)),
      descriptionClassName: 'max-h-96 overflow-auto toaster-error',
      ...options
    })
  },
  warning: (message, options = {}) => {
    toast.warning(renderToString(<Trans i18nKey='ui.warning' />), {
      description: parse(parseMessage(message)),
      descriptionClassName: 'max-h-96 overflow-auto',
      ...options
    })
  },
  info: (message, options = {}) => {
    toast.info(renderToString(<Trans i18nKey='ui.info' />), {
      description: parse(parseMessage(message)),
      descriptionClassName: 'max-h-96 overflow-auto',
      ...options
    })
  }
}

const parseMessage = (message) => {
  if (Array.isArray(message)) {
    let buildMessage = ''

    message.forEach((m, i) => {
      buildMessage += `${(i + 1)}. ${m} <br>`
    })

    return buildMessage
  }

  return message
}
